'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MESSAGE_TYPE_ID = exports.MESSAGE_TYPE_ID = '@type';
var ASSIGNMENT = exports.ASSIGNMENT = 'ASSIGNMENT';
var ASSIGNMENT_V2 = exports.ASSIGNMENT_V2 = 'ASSIGNMENT_V2';
var BLOCK = exports.BLOCK = 'BLOCK';
var CHAT_MESSAGE = exports.CHAT_MESSAGE = 'CHAT_MESSAGE';
var CLOSE_THREAD = exports.CLOSE_THREAD = 'CLOSE_THREAD';
var CONNECTED_ACCOUNT_STATUS_UPDATE = exports.CONNECTED_ACCOUNT_STATUS_UPDATE = 'CONNECTED_ACCOUNT_STATUS_UPDATE';
var CONNECTED_ACCOUNT_UPDATE = exports.CONNECTED_ACCOUNT_UPDATE = 'CONNECTED_ACCOUNT_UPDATE'; // deprecated
var CONTEXT_UPDATE = exports.CONTEXT_UPDATE = 'CONTEXT_UPDATE';
var CRM_OBJECT_LIFECYCLE_UPDATE = exports.CRM_OBJECT_LIFECYCLE_UPDATE = 'CRM_OBJECT_LIFECYCLE_UPDATE';
var CRM_OBJECT_WORKFLOW_EMAIL_SENT = exports.CRM_OBJECT_WORKFLOW_EMAIL_SENT = 'CRM_OBJECT_WORKFLOW_EMAIL_SENT';
var EMAIL_CAPTURE_PROMPT = exports.EMAIL_CAPTURE_PROMPT = 'EMAIL_CAPTURE_PROMPT';
var EMAIL_CAPTURE_RESPONSE = exports.EMAIL_CAPTURE_RESPONSE = 'EMAIL_CAPTURE_RESPONSE';
var INITIAL_MESSAGE = exports.INITIAL_MESSAGE = 'INITIAL_MESSAGE';
var JOIN_CHANNEL = exports.JOIN_CHANNEL = 'JOIN_CHANNEL';
var LAST_SEEN = exports.LAST_SEEN = 'LAST_SEEN';
var OFFICE_HOURS = exports.OFFICE_HOURS = 'OFFICE_HOURS';
var THREADS_REMOVED_FROM_VIEW = exports.THREADS_REMOVED_FROM_VIEW = 'THREADS_REMOVED_FROM_VIEW';
var THREADS_UPDATED = exports.THREADS_UPDATED = 'THREADS_UPDATED';
var THREADS_UPDATED_BULK = exports.THREADS_UPDATED_BULK = 'THREADS_UPDATED_BULK';
var THREADS_UPDATED_RATE_LIMITED = exports.THREADS_UPDATED_RATE_LIMITED = 'THREADS_UPDATED_RATE_LIMITED';
var TYPICAL_RESPONSE_TIME = exports.TYPICAL_RESPONSE_TIME = 'TYPICAL_RESPONSE_TIME';
var OFFLINE = exports.OFFLINE = 'OFFLINE';
var OPEN_THREAD = exports.OPEN_THREAD = 'OPEN_THREAD';
var UNASSIGNMENT = exports.UNASSIGNMENT = 'UNASSIGNMENT';
var CHAT_RICH_TEMPLATE = exports.CHAT_RICH_TEMPLATE = 'CHAT_RICH_TEMPLATE';
var TYPING = exports.TYPING = 'TYPING';
var FILTERED_CHANGE = exports.FILTERED_CHANGE = 'FILTERED_CHANGE';
var CONTACT_ASSOCIATION = exports.CONTACT_ASSOCIATION = 'CONTACT_ASSOCIATION';
var READ_THREAD = exports.READ_THREAD = 'READ_THREAD';
var COMMON_MESSAGE = exports.COMMON_MESSAGE = 'COMMON_MESSAGE';
var THREAD_COMMENT = exports.THREAD_COMMENT = 'THREAD_COMMENT';
var THREAD_DELETED_STATUS_UPDATE = exports.THREAD_DELETED_STATUS_UPDATE = 'THREAD_DELETED_STATUS_UPDATE';